export default "__VITE_ASSET__CsTuZgyA__"